
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4H5.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C1 6.28 1 7.12 1 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C3.28 22 4.12 22 5.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.31C19 19.72 19 18.88 19 17.2V13M7 16h1.675c.489 0 .733 0 .963-.055a2 2 0 00.579-.24c.201-.123.374-.296.72-.642L20.5 5.5a2.121 2.121 0 00-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 00-.24.579c-.055.23-.055.474-.055.964V16z","stroke":"#232859","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    